import { createContext } from 'react';
import { ID } from 'shared/types/id';

export type DeleteGoalsContextProps = {
  onDeleteGoals: (ids: ID[]) => void;
};

export const DeleteGoalsContext = createContext<DeleteGoalsContextProps>({
  onDeleteGoals: () => {},
});
